module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      A. E. W. Mason\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("A. E. W. Mason (1865–1948) was a bestselling author of mystery and adventure fiction. He is best remembered for the novel "), _c('I', [_vm._v("The Four Feathers ")]), _vm._v("and for his series of mysteries featuring Inspector Hanaud of the Paris Sûreté.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oqEWyv/tc-custom/9781497672529.jpg?1705492240047",
      "alt": "This image is the cover for the book Four Corners of the World"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Four Corners of the World\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A scintillating collection of mysteries and adventures from the brilliant mind of A. E. W. Mason")]), _c('br'), _c('br'), _vm._v(" When Archie Cranfield’s father asked Mr. Twiss to look after his son as well as advise him financially, the solicitor had no idea what he was agreeing to. A furtive smile permanently etched on his face, Archie lives alone in the countryside. His neighbors do not like him, and Captain Brayton, a former schoolmate, had a falling-out with him years ago and has not seen him since. Then the oddest surprise of all—Archie invites Brayton for a weekend visit and the captain winds up dead. Is it suicide, or is the young Mr. Cranfield as guilty as he looks?"), _c('br'), _c('br'), _vm._v(" “The Clock” is the first of thirteen enthralling tales of suspense in "), _c('i', [_vm._v("The Four Corners of the World")]), _vm._v(". A. E. W. Mason’s masterful collection moves from Gibralter to South America, from a brutal wartime drama to a terrible murder solved by the inimitable Inspector Hanaud."), _c('br'), _c('br'), _vm._v(" This ebook has been professionally proofread to ensure accuracy and readability on all devices. \n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0